import { render, staticRenderFns } from "./ComprehensivePlan.vue?vue&type=template&id=0b1cdf0d&scoped=true"
import script from "./ComprehensivePlan.vue?vue&type=script&lang=js"
export * from "./ComprehensivePlan.vue?vue&type=script&lang=js"
import style0 from "./ComprehensivePlan.vue?vue&type=style&index=0&id=0b1cdf0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1cdf0d",
  null
  
)

export default component.exports